'use client'


import React from 'react';
import { useTransitionRouter as useRouter } from 'next-view-transitions'
import styles from './not-found.module.css';

export default function Index() {
  const $router = useRouter();

  function back() {
    $router.back();
  }
  return (
    <div className={styles.wrapper}>
      <div className={styles.context}>
        <p className={styles['not-found']}>page not found</p>
        <div className={styles['tipsize']}>
          <div className={styles['tipsiz-body']}>
            <div className={`${styles['left-arm']} ${styles['arm']}`}></div>
            <div className={styles.face}>
              <div className={styles['upper-face']}>
                <div className={styles.element}>4</div>
                <div className={styles.element}>0</div>
                <div className={styles.element}>4</div>
              </div>
              <div className={styles.mouth}></div>
            </div>
            <div className={`${styles['right-arm']} ${styles['arm']}`}></div>
          </div>
        </div>
        <p className={styles['back']}>maybe you want to go
          <span onClick={back}> back?</span>
        </p>
      </div>
    </div>
  )
}
